const initAddCardsButton = (container, visibleItems, itemsToAdd) => {
  const addButtonsContainer = document.querySelector(container);
  if (!addButtonsContainer) {
    return;
  }
  const addButton = addButtonsContainer.querySelector('[data-add-button]');
  const list = addButton.parentElement.querySelector('[data-add-button-content]');
  const listItems = list.querySelectorAll('[data-add-button-item]');

  const setNumberOfCards = (list, button, currentVisibleCards) => {
    list.forEach((card, index) => {
      if (card.classList.contains('is-hidden') && index < currentVisibleCards) {
        card.classList.remove('is-hidden');
      }
    });
    if (currentVisibleCards >= list.length) {
      button.classList.add('is-hidden');
    }
  };

  const initList = (list, button, visibleCards, cardsToAdd) => {
    let currentVisibleCards = visibleCards;
    if (list.length <= visibleCards) {
      button.classList.add('is-hidden');
    } else {
      list.forEach((card, index) => {
        if (index >= visibleCards) {
          card.classList.add('is-hidden');
        }
      });
      button.addEventListener('click', () => {
        currentVisibleCards = currentVisibleCards + cardsToAdd;
        setNumberOfCards(list, button, currentVisibleCards);
      });
    }
  };

  initList(listItems, addButton, visibleItems, itemsToAdd);
};

export default initAddCardsButton;
